type GridCheckboxParams = {
  api: {
    selectedProsForCityRoute?: Set<string>;
    toggleProsForCityRoute?: (proId: string, isSelected: boolean) => void;
    forEachNode?: (callback: (node: { data: { proId: string } }) => void) => void;
  };
  data?: { proId: string };
};

export const checkIfProSelectedForCityRoute = (params: GridCheckboxParams) => {
  const proId = params.data?.proId;
  if (!proId) {
    return false;
  }
  const selectedProsForCityRoute = params.api.selectedProsForCityRoute;
  return selectedProsForCityRoute?.has(proId) ?? false;
};

export const handleCityRouteCheckboxToggle = (params: GridCheckboxParams, isChecked: boolean) => {
  const proId = params.data?.proId;
  if (!proId) {
    return;
  }
  params.api.toggleProsForCityRoute?.(proId, isChecked);
};

export const checkIfAllProsSelectedForCityRoute = (params: GridCheckboxParams) => {
  const selectedProsForCityRoute = params.api.selectedProsForCityRoute;
  if (!selectedProsForCityRoute || selectedProsForCityRoute.size === 0) {
    return false;
  }

  let allSelected = true;
  let hasVisibleProId = false;
  params.api.forEachNode?.((node) => {
    const proId = node.data?.proId;
    if (!proId) {
      return;
    }
    hasVisibleProId = true;
    if (!selectedProsForCityRoute.has(proId)) {
      allSelected = false;
    }
  });
  return hasVisibleProId && allSelected;
};

export const handleCityRouteCheckboxToggleForAll = (params: GridCheckboxParams, isChecked: boolean) => {
  if (!params.api.toggleProsForCityRoute || !params.api.forEachNode) {
    return;
  }

  params.api.forEachNode((node) => {
    const proId = node.data?.proId;
    if (!proId) {
      return;
    }
    params.api.toggleProsForCityRoute?.(proId, isChecked);
  });
};

export const constructSelectedShipmentsStatusBar = (
  data: Array<{ proId: string }>,
  selectedProsForCityRoute: Set<string>
) => {
  const selectedCount = data.filter((shipment) => selectedProsForCityRoute.has(shipment.proId)).length;
  return [
    { label: `${data.length} Total Shipments` },
    { label: `${selectedCount} Selected Shipments` }
  ];
};
